import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const DoctorsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Doctors Page
      </Typography>
      <Typography variant="body1">
        Doctor management coming soon...
      </Typography>
    </Container>
  );
};

export default DoctorsPage;
